'use client';

import { createContext, useContext } from 'react';

export const CookieConsentContext = createContext<{
  openSettings: () => void;
  settings: { key: string; enabled: boolean }[];
}>({
  openSettings: () => {},
  settings: [],
}); 

export const useCookieConsent = () => useContext(CookieConsentContext); 